// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3149":"54b34290","5122":"54b34290"}[chunkId] + ".chunk.css";
};